import AboutProfile from "./AboutProfile";
export default AboutProfile;
